var configurator;
var configuratorDOMTargetSelector = "body";
var configuratorScrollbar = null;
var iframeconfiguratorScrollbar = null;
var configuratorid = "confId";
var OneDealerConfiguratorType = {
	Jato: function() {
		return "Jato";
	},
	Light: function() {
		return "Light";
	},
	LightEdit: function() {
		return "LightEdit";
	}
}
var OneDealerConfiguratorOptions = function() {
	return {
		Urls: {
			baseUrl: null,
			returnUrl: "IFrameRedirect"
		},
		Style: {
			height: null,
			width: null
		},
		targetElementSelectorToInject: null
	}
}
var dialogWindow = null;
var OneDealerVehicleConfigurator = function() {
	var self = this;
	var options = {
		Urls: {
			baseUrl: "",
			returnUrl: "",
			configuratorBaseUrl :""
		},
		Style: {
			height: 600,
			width: 600
		},
		targetElementSelectorToInject: "body",
		configuratorId: "",
		configuratorContainerId: "",
		closeCallback: "",
		selectedConfigurator: null
	}
	this.configuratorOnLoadEvents = {
		Jato: function( element ) {
			var returnUrl = options.Urls.returnUrl.toLowerCase();
			if ( element.contentWindow.location && element.contentWindow.location.toString().toLocaleLowerCase().indexOf( returnUrl ) > -1 ) {
				self.HideConfigurator();
				var uri = new URI( element.contentWindow.location.search );
				var vehicleid = '';
				var _options = '';
				var configurationId = '';
				uri.hasQuery( "vehicle", function( value, name, data ) {
					vehicleid = value;
					return true;
				} );
				uri.hasQuery( "Options", function( value, name, data ) {
					if ( value )
						_options = value;
					return true;
				} );
				uri.hasQuery( "shelf", function( value, name, data ) {
					if ( value )
						configurationId = value;
					return true;
				} );
				if ( typeof( self.OnVehicleSelected ) == "function" )
					self.OnVehicleSelected( vehicleid, _options, configurationId );
				else
					console.warn( "Vehicle was selected but no callback function is set." );
			}
		},
		Light: function( element ) {
			var returnUrl = options.Urls.returnUrl.toLowerCase();
			if ( element.contentWindow.location && element.contentWindow.location.toString().toLocaleLowerCase().indexOf( returnUrl ) > -1 ) {
				self.HideConfigurator();
				var uri = new URI( element.contentWindow.location.search );
				var configurationId = '';
				uri.hasQuery( "conf", function( value ) {
					configurationId = value;
					return true;
				} );
				if ( typeof( self.OnVehicleSelected ) == "function" ) {
					console.warn( "Vehicle was selected" );
					self.OnVehicleSelected( configurationId );
				} else
					console.warn( "Vehicle was selected but no callback function is set." );
			}
		},
		LightEdit: function( element ) {
			var returnUrl = options.Urls.returnUrl.toLowerCase();
			if ( element.contentWindow.location && element.contentWindow.location.toString().toLocaleLowerCase().indexOf( returnUrl ) > -1 ) {}
		}
	}
	this.configuratorRawHtml = {
		Jato: function() {
			var baseUrlWithBackslash = options.Urls.baseUrl[ options.Urls.baseUrl.length - 1 ] == "/" ? options.Urls.baseUrl : options.Urls.baseUrl + "/";
			return '<aside id="' + options.configuratorContainerId + '" class="configurator-container right-side strech" style="height:100%;"><section class="content" style="background-color: #fff; float:none; -webkit-overflow-scrolling: touch; position:relative;padding: 0 0 20px 0; width: 100%; height: 100%; overflow: auto; -webkit-overflow-scrolling: touch;display: inline-block;"><iframe scrolling="yes" style="width:100%; border: none; position:relative; padding-left: 15px;" src="http://tesseramultimedia.net/car-configurator-v2/#/makes?returnurl=' + baseUrlWithBackslash + options.Urls.returnUrl + '"  id="' + options.configuratorId + '"></iframe></section></aside>';
		},
		Light: function( makeCode ) {
			var encodedEndpointUrl = options.Urls.baseUrl.replace( /\//g, '*' );
			var encodedReturnPath = options.Urls.returnUrl.replace( /\//g, '*' );
			var finalUrl = options.Urls.configuratorBaseUrl + "/#!/app/endpoint=" + encodedEndpointUrl + "&redirectionPath=" + encodedReturnPath + "/car/make/" + makeCode + "/family/";
			console.log( "LightConfigurator iframe url :" + finalUrl );
			return '<aside id="' + options.configuratorContainerId + '" class="configurator-container right-side strech" style="height:100%;"><section class="content" style="background-color: #fff; float:none; -webkit-overflow-scrolling: touch; position:relative;padding: 0; width: 100%; height: 100%; overflow: auto; -webkit-overflow-scrolling: touch;display: inline-block;"><iframe scrolling="yes" style="width:100%; border: none; position:relative;" src="' + finalUrl + '"  id="' + options.configuratorId + '"></iframe></section></aside>';
		},
		LightEdit: function( savedConfigurationId ) {
			var encodedEndpointUrl = options.Urls.baseUrl.replace( /\//g, '*' );
			var encodedReturnPath = options.Urls.returnUrl.replace( /\//g, '*' );
			var finalUrl = options.Urls.configuratorBaseUrl + "/#!/app/editId=" + savedConfigurationId + "&endpoint=" + encodedEndpointUrl + "&redirectionPath=" + encodedReturnPath;
			console.log( "LightConfigurator iframe url :" + finalUrl );
			return '<aside id="' + options.configuratorContainerId + '" class="configurator-container right-side strech" style="height:100%;"><section class="content" style="background-color: #fff; float:none; -webkit-overflow-scrolling: touch; position:relative;padding: 0; width: 100%; height: 100%; overflow: auto; -webkit-overflow-scrolling: touch;display: inline-block;"><iframe scrolling="yes" style="width:100%; border: none; position:relative;" src="' + finalUrl + '"  id="' + options.configuratorId + '"></iframe></section></aside>';
		}
	}
	this.Init = function( userOptions ) {
		options.Urls.baseUrl = userOptions.Urls.baseUrl !== null ? userOptions.Urls.baseUrl : options.Urls.baseUrl;
		options.Urls.returnUrl = userOptions.Urls.returnUrl !== null ? userOptions.Urls.returnUrl : options.Urls.returnUrl;
		options.Urls.configuratorBaseUrl = userOptions.Urls.configuratorSourceUrl !== null? userOptions.Urls.configuratorSourceUrl : options.Urls.configuratorBaseUrl;
		options.Style.height = userOptions.Style.height !== null ? userOptions.Style.height : options.Style.height;
		options.Style.width = userOptions.Style.width !== null ? userOptions.Style.width : options.Style.width;
		options.targetElementSelectorToInject = userOptions.targetElementSelectorToInject !== null ? userOptions.targetElementSelectorToInject : options.targetElementSelectorToInject;
		options.closeCallback = userOptions.closeCallback !== null ? userOptions.closeCallback : options.closeCallback;
	}
	this.OpenConfigurator = function( configuratorType, confTypeOptions ) {
		options.configuratorId = configuratorid;
		options.configuratorContainerId = configuratorid;
		if ( typeof( configuratorType ) != "function" && typeof( configuratorType ) != "string" )
			return console.warn( "The configurator type :\"" + configuratorType + "\" is not a valid type." );
		var typeString = typeof( configuratorType ) == "function" ? configuratorType() : configuratorType;
		if ( typeof( typeString ) != "undefined" ) {
			options.selectedConfigurator = typeString;
			var html = null;
			if ( typeof( confTypeOptions ) != "undefined" && confTypeOptions !== "" ) {
				html = self.configuratorRawHtml[ typeString ]( confTypeOptions );
			} else {
				html = self.configuratorRawHtml[ typeString ]();
			}
			$( function() {
				$( configuratorDOMTargetSelector ).append( html )
				// $( window ).unload();
				$(window).on("unload", function(e) {});
			} );
			self._attachOnLoadEvent();
		}
		window.addEventListener( "message", function( event ) {
			if ( event.data !== null && event.origin === options.Urls.baseUrl){
				if ( self.OnVehicleSelected !== null ) {
					self.OnVehicleSelected( event.data.split( "=" )[ 1 ] );
				}
			}
		}, false );
	};
	this.CloseConfigurator = function() {};
	this.HideConfigurator = function() {
		$( '#' + options.configuratorContainerId ).css( 'display', 'none' );
	}
	this._attachOnLoadEvent = function() {
		$( "#" + options.configuratorId ).on('load', function () {
			var element = this;
			if ( options.selectedConfigurator === null ) {
				console.log( "OneDealerVehicleConfigurator.js - Could not attach configurator load event. Select a valid configurator." );
				return false;
			}
			self.configuratorOnLoadEvents[ options.selectedConfigurator ]( element );
		} );
	}
};
//The rest are initiallized in interestForm.js
// configurator = new OneDealerVehicleConfigurator();
// var configuratorOptions = new OneDealerConfiguratorOptions();
// //The endpoint of the configurator
// configuratorOptions.Urls.configuratorSourceUrl = "https://configuratorkosmo-staging.onedealer.com";
// //The endpoint that the configurator will use to get it's dataset
// configuratorOptions.Urls.baseUrl = "https://karenta-onedealer.kosmocar.gr";
// //The final URL that will be hit after the configuration ends
// configuratorOptions.Urls.returnUrl = "/IframeRedirect/ActionFinisher";
// configuratorOptions.closeCallback = function() {};
// configurator.Init( configuratorOptions );